import React from 'react';

function RegistrationStepper({ completedStep = 0, activeStep = 1 }) {
  const isStep1Done = completedStep >= 1;
  const isStep1Active = activeStep === 1 && !isStep1Done;
  const isStep2Active = activeStep === 2;
  const isConnectorActive = isStep1Done;

  return (
    <nav className="reg-seller-stepper" aria-label="Registration progress">
      <div className="reg-seller-stepper__track">
        <div
          className={`reg-seller-stepper__step${
            isStep1Done ? ' reg-seller-stepper__step--done' : ''
          }${isStep1Active ? ' reg-seller-stepper__step--active' : ''}`}
        >
          <span className="reg-seller-stepper__circle" aria-hidden="true">
            {isStep1Done ? <i className="bi bi-check-lg" /> : '1'}
          </span>
          <span className="reg-seller-stepper__label">
            <span className="reg-seller-stepper__step-num">Step 1</span>
            <span className="reg-seller-stepper__step-name">Basic Information</span>
          </span>
        </div>

        <div
          className={`reg-seller-stepper__connector${
            isConnectorActive ? ' reg-seller-stepper__connector--active' : ''
          }`}
          aria-hidden="true"
        />

        <div
          className={`reg-seller-stepper__step${
            isStep2Active ? ' reg-seller-stepper__step--active' : ''
          }${!isStep2Active && !isStep1Done ? ' reg-seller-stepper__step--pending' : ''}`}
        >
          <span className="reg-seller-stepper__circle" aria-hidden="true">
            2
          </span>
          <span className="reg-seller-stepper__label">
            <span className="reg-seller-stepper__step-num">Step 2</span>
            <span className="reg-seller-stepper__step-name">Key Products</span>
          </span>
        </div>
      </div>
    </nav>
  );
}

export default RegistrationStepper;
